import { getTracer } from '@thoughtspot/observability';
const NOOP_SPAN = {
    setAttribute: () => NOOP_SPAN,
    setAttributes: () => NOOP_SPAN,
    addEvent: () => NOOP_SPAN,
    setStatus: () => NOOP_SPAN,
    updateName: () => NOOP_SPAN,
    end: () => { },
    isRecording: () => false,
    recordException: () => { },
    spanContext: () => ({
        traceId: '',
        spanId: '',
        traceFlags: 0,
    }),
};
export function startSpan(op, parentCtx, enabled, attributes = {}) {
    if (!enabled || !parentCtx)
        return NOOP_SPAN;
    try {
        return getTracer('plain-table').startSpan(op.name, { attributes: { 'span.description': op.description, ...attributes } }, parentCtx);
    }
    catch (_a) {
        return NOOP_SPAN;
    }
}
//# sourceMappingURL=tracer.js.map